import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import QuestionSetForm from '../../../components/forms/QuestionSetForm';
import { useQuestionSetApi } from '../../../hooks/useQuestionSetApi';
import { useNavigate } from 'react-router-dom';
import { QuestionSetDTO } from '../../../services/apiClient';

const QuestionSetCreate: React.FC = () => {
  const { create, isLoading } = useQuestionSetApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Question Sets', href: '/admin/questionsets' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: QuestionSetDTO) => {
    try {
      await create(data);
      navigate('/admin/questionsets');
    } catch (error) {
      console.error('Error creating QuestionSet:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/questionsets"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Content.QuestionSet.Edit'
    >
        <QuestionSetForm
          initialValues={{} as QuestionSetDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/questionsets')}
        />
    </AdminLayout>
  );
};

export default QuestionSetCreate;